<template>
	<component :is="element" :to="to" :href="href" :target="target" :class="classes" @click="onClick">
		<UiRow gap="2" align="center" justify="center">
			<UiLoadingSpinner v-if="loading"></UiLoadingSpinner>
			<slot></slot>
		</UiRow>
	</component>
</template>

<script setup>
	import { computed } from "vue"
	import { useRouter } from "vue-router"
	import UiLoadingSpinner from "./LoadingSpinner"

	const router = useRouter()

	const props = defineProps({
		size: {
			type: String,
			default: "m"
		},
		color: {
			type: String,
			default: "primary"
		},
		full: Boolean,
		round: Boolean,
		to: String,
		href: String,
		target: String,
		as: {
	      type: String,
	      default: 'div'
	    },
	    loading: Boolean,
	    disabled: Boolean
	})

	const classes = computed(() => [
		"btn",
		`btn-${props.size}`,
		`btn-${props.color}`,
		props.full && 'btn-full',
		props.round && 'btn-round',
	])

	const element = computed(() => {
		if (props.to) {
	        return "div";
	     }
	    if (props.href) {
	        return "a";
	     }
	      
	      return props.as;
	})

	const onClick = () => {
		if (props.disabled) return

		if (props.to) router.push(props.to)
	}
</script>

<style>
	.btn {
	  background: var(--color-brand);
	  color: #ffffff;
	  border-radius: 12px;
	  padding: 12px 24px;
	  font-weight: 600;
	  line-height: 20px;
	  letter-spacing: -0.21px;
	  font-size: 14px;
	  display: inline-block;
	  text-align: center;
	  cursor: pointer;
	  border: none;
	  text-align: center;
	}

	.btn-s {
	  height: 40px;
	  padding: 10px 24px;
	  font-weight: 600;
	  line-height: 20px;
	  font-size: 14px;
	}

	.btn-l {
	  height: 52px;
	  padding: 16px 32px;
	  font-size: 16px;
	}

	.btn-full {
	  width: 100%;
	}

	.btn-inv {
	  background: #ffffff;
	  color: var(--color-brand);
	}

	.btn-link {
	  background: transparent;
	  color: var(--color-brand);
	}

	.btn-black {
	  background: #171C1A;
	}

	.btn-gray {
	  background: #f3f3f3;
	  color: var(--color-brand);
	}

	.btn-gray .simple-spinner span {
	  border-right-color: var(--color-brand);
	}

	.btn-disabled {
	  background: #f3f3f3;
	  color: #cdcdcd;
	}

	.btn-disabled .simple-spinner span {
	  border-right-color: var(--color-brand);
	}

	.btn-outline {
	  background: #ffffff;
	  color: var(--color-brand);
	  border: 1px solid var(--color-brand);
	  font-weight: 400;
	}

	.btn-cta {
	  background: rgb(68,227,148);
	  background: linear-gradient(90deg, rgba(68,227,148,1) 0%, rgba(44,228,137,1) 100%);
	}
	.btn-full {
		width: 100%;
	}
	.btn-success {
		background: #87F57D;
		color: #000;
	}
	.btn-danger {
		background: #FF2C46;
		color: #fff;
	}
	.btn-round {
		border-radius: 999px;
	}
</style>